// extracted by mini-css-extract-plugin
export default {"contentModal":"ModalDeleteProduct_contentModal__2R+AG","titleModal":"ModalDeleteProduct_titleModal__vMBzU","textModal":"ModalDeleteProduct_textModal__aOKu4"};